/* eslint-disable import/prefer-default-export */
import { assign } from 'xstate';
import { MESSAGES, PAGE_FUNCTION, PAGE_NAME, SUB_FUNCTION } from '../../const/analytics';
import { paymentTypes } from '../../const/paymentOptions';
import { getAnalyticsMessageType, getPaymentFlowFormValues } from '../helpers';
export const savePaymentResult = assign({
    paymentResult: (context, { data }) => {
        return data;
    }
});
export const submitFailureAnalyticsHandler = () => {
    return {
        pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS,
        pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.PAYMENT,
        pageName: PAGE_NAME.MAKE_PAYMENT.FAILED,
        message: 'paymentTypePayoff',
        errorMessage: MESSAGES.ERROR.MAKE_PAYMENT.PAYMENT_FAILED
    };
};
const getPageNameForReview = (paymentMethod) => {
    const { REVIEW_CHECKING, REVIEW_DEBIT, REVIEW_SAVINGS, REVIEW_CREDIT } = PAGE_NAME.MAKE_PAYMENT;
    if (paymentMethod.paymentMedium === 'PINLESS_DEBIT_CARD')
        return REVIEW_DEBIT;
    if (paymentMethod.paymentMedium === 'CREDIT_CARD')
        return REVIEW_CREDIT;
    if (paymentMethod.type === 'CHECKING')
        return REVIEW_CHECKING;
    return REVIEW_SAVINGS;
};
export const submitSuccessAnalyticsHandler = (context) => {
    const messageType = getAnalyticsMessageType(context.apiMachineRef, paymentTypes.PAYOFF);
    return Object.assign({ pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS, pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.PAYMENT, pageName: PAGE_NAME.COMPLETE, message: 'paymentTypePayoff' }, (messageType && { messageType }));
};
export const submitReviewAnalyticsHandler = (context) => {
    const [, paymentMethod] = getPaymentFlowFormValues(context);
    const messageType = getAnalyticsMessageType(context.apiMachineRef, paymentTypes.PAYOFF);
    return Object.assign({ pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS, pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.PAYOFF_REVIEW, pageName: getPageNameForReview(paymentMethod), message: 'payoff' }, (messageType && { messageType }));
};
